import React     from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';

import * as S from './prod-name.module.scss';

// This component will make you want to cry, you've been warned.
const isNonEmptyObject = (obj) => {
  return typeof obj === 'object' && obj !== null && Object.keys(obj).length > 0;
};

const nameContent = (sub, product, nameStyle, customName) => {
  // console.log('nameContent');
  // console.log('sub:', sub);
  // console.log('product:', product);
  // console.log('nameStyle:', nameStyle);
  // console.log('customName:', customName);
  // console.log('_________________________');


  if(!sub && !customName) {
    console.warn('Product name component missing sub or override name');
    console.warn('Sub: ');
    console.warn(sub);
    console.warn('customName: ' + customName);
    return (<> {sub.productLineName} {sub.tierName} </>);
  }

  const simpNames = ['acme', 'simplifi'];
  const isSimplifi = simpNames?.includes(sub?.productLineName?.toLowerCase()) || simpNames?.includes(product?.toLowerCase());
  // console.log('isSimplifi:', isSimplifi);

  const isQknSub = ['quicken', 'quicken us', 'quicken canada', 'quicken-us', 'quicken-ca']?.includes(sub?.productLineName?.toLowerCase());
  const isQknProduct = product ? ['quicken', 'quicken us', 'quicken canada', 'quicken-us', 'quicken-ca']?.includes(product?.toLowerCase()) : false;
  const isQuicken =  isQknSub || isQknProduct;

  const isQem = sub?.productLineName?.toLowerCase() === 'quicken lifehub' || product === 'quicken lifehub';
  const isQob = sub?.productLineName?.toLowerCase() === 'quicken online backup' || product === 'online backup';

  const bmNames = ['bill manager', 'billmanager', 'billmanager promotion', 'bill manager promotion'];
  const isBm = bmNames?.includes(sub?.productLineName?.toLowerCase()) || bmNames.includes(product?.toLowerCase());

  if (isQem) {
    if(nameStyle === 'textOnly') {
      return 'LifeHub';
    } else {
      return ('LifeHub');
    }
  } else if (isSimplifi) {
    if (customName && nameStyle === 'textOnly') {
      if (customName === 'Acme-basic') customName = 'Simplifi';
      if (customName === 'Acme-hab') customName = 'Business & Personal';
      return `${customName}`;
    } else if (customName) {
      if (customName === 'Acme-basic') customName = 'Simplifi';
      if (customName === 'Acme-hab') customName = 'Business & Personal';
      return (<>{customName}</>);
    } else if (nameStyle === 'textOnly') {
      return `${sub.tierName}`;
    } else {
      return (<>{sub.tierName}</>);
    }
  } else if (isQuicken) {
    if(customName && nameStyle === 'textOnly') {
      return `Classic ${customName}`;
    } else if (customName) {
      return (<>Classic {customName}</>);
    } else if (nameStyle === 'textOnly') {
      return `Classic ${sub.tierName}`;
    } else {
      return (<>Classic {sub.tierName}</>);
    }
  } else if (isQob) {
    if (nameStyle === 'textOnly') {
      return 'Online Backup';
    } else {
      return (<>Online Backup</>);
    }
  } else if (isBm) {
    if (customName) {
      return (<> {customName} </>);
    } else if(nameStyle === 'textOnly') {
      return `${sub?.productLineName} ${sub?.tierName}`;
    } else {
      return (<> {sub?.productLineName} {sub?.tierName} </>);
    }
  } else {
    return '';
  }
};

const ProductName = ({ sub, className, product, nameStyle, customName }) => {
  // console.log('customName before:', customName);
  customName = customName ? customName.charAt(0).toUpperCase() + customName.slice(1) : false;
  // console.log('sub:', sub);
  // console.log('className:', className);
  // console.log('product:', product);
  // console.log('nameStyle:', nameStyle);
  // console.log('customName after:', customName);
  // console.log('_________________________');
  // Not everything passed in here is a full sub response so check and use a true fallback
  // const arCheck = sub?.autoRenew || true;
  let arCheck = true;
  if (typeof sub === 'object') {
    arCheck = ('autoRenew' in sub) ? sub.autoRenew : true;
  }

  if (!product && !isNonEmptyObject(sub) && !customName) {
    return (<div className={ClassNames(S.prodName, className)}></div> );
  }

  if (nameStyle === 'inline' || nameStyle === 'textOnly'){
    return (<span className={ClassNames(S.prodName, className)}> {nameContent(sub, product, nameStyle, customName)} </span>);
  } else {
    return (<div className={ClassNames(S.prodName, className, { [S.hasArOff]: !arCheck })}> {nameContent(sub, product, nameStyle, customName)} </div>);
  }
};

ProductName.displayName = 'CompanyBox';
ProductName.propTypes   = {
  sub: PropTypes.object,
  className: PropTypes.string,
  customName: PropTypes.string,
  style: PropTypes.string
};
ProductName.defaultProps ={
  inline : false
};

export { ProductName };
